import { type FC } from "react";
import { KeepForm } from "@userFrontend/features/publication/components/KeepForm";
import { Link } from "@root/shared/components/Link";
import { EntryButtonSection } from "../EntryButtonSection";
import { type ButtonsProps } from "../../types";
import * as styles from "./styles.css";

export const PcButtons: FC<ButtonsProps> = ({
  showKeepButton,
  keepFormProps,
  detailLinkProps,
  entryButtonSectionProps,
  onClickLink,
}) => {
  return (
    <div className={styles.container}>
      {/* キープボタン */}
      {showKeepButton && (
        <div className={styles.item}>
          <KeepForm
            url={keepFormProps.url}
            query={keepFormProps.query}
            gaAction={keepFormProps.gaAction}
            gaLabel={keepFormProps.gaLabel}
            firebaseAction={keepFormProps.firebaseAction}
            workCode={keepFormProps.workCode}
            hasKeeped={keepFormProps.hasKeeped}
          />
        </div>
      )}

      {/* 詳細を見るボタン */}
      <div className={styles.item}>
        <Link
          href={detailLinkProps.href}
          theme="tertiary"
          className="ga-click appier-click"
          data-ga-action={detailLinkProps.gaAction}
          data-ga-label={detailLinkProps.gaLabel}
          data-appier-action={detailLinkProps.appierAction}
          onClick={(event) => {
            onClickLink({
              url: detailLinkProps.href,
              query: detailLinkProps.queryString ?? "",
              event,
            });
          }}
        >
          詳細を見る
        </Link>
      </div>

      {/* 応募ボタン */}
      <div className={styles.item}>
        <EntryButtonSection {...entryButtonSectionProps} onClickLink={onClickLink} />
      </div>
    </div>
  );
};
